// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"5bbaa316","513":"f8cac0ab","703":"6569ad27"}[chunkId] + ".chunk.js";
};